<template>
  <div>
    <layout-header class="header" />
    <div class="page-content-container">
      <router-view class="page-content" />
    </div>
  </div>
</template>

<script>
import LayoutHeader from "../components/layout-header";

export default {
  components: {
    LayoutHeader
  }
}
</script>

<style lang="sass" scoped>
.header
  position: absolute
  top: 0px
  left: 0px
  right: 0px
  height: $header-height-desktop
.page-content-container
  position: absolute
  top: $header-height-desktop
  left: 0px
  right: 0px
  overflow: auto
  overflow-x: hidden
  margin: 0px
  background: $background
.page-content
  margin: 10px
@media (max-width: 576px)
  .header
    height: $header-height-mobile
  .page-content-container
    top: $header-height-mobile
</style>